module.exports = __webpack_public_path__ + "static/media/dev-7.e2eaef41.png";